/**
 * Categorias de gasto. Espelha o enum `CategoriaInsumo` do backend.
 *
 * A lista estava duplicada em `Insumos.js`; agora o lançamento de custo também
 * precisa dela, então virou fonte única. Se um valor for adicionado no enum
 * Java, é aqui que entra o rótulo.
 */
export const CATEGORIAS = [
  { value: 'SEMENTE',          label: 'Semente' },
  { value: 'MUDA',              label: 'Muda' },
  { value: 'FERTILIZANTE',     label: 'Fertilizante' },
  { value: 'CORRETIVO',        label: 'Corretivo (calcário/gesso)' },
  { value: 'INOCULANTE',       label: 'Inoculante' },
  { value: 'HERBICIDA',        label: 'Herbicida' },
  { value: 'FUNGICIDA',        label: 'Fungicida' },
  { value: 'INSETICIDA',       label: 'Inseticida' },
  { value: 'BACTERICIDA',      label: 'Bactericida' },
  { value: 'DEFENSIVO',        label: 'Defensivo (geral)' },
  { value: 'COMBUSTIVEL',      label: 'Combustível' },
  { value: 'EMBALAGEM',        label: 'Embalagem' },
  { value: 'SERVICO',          label: 'Serviço' },
  { value: 'OUTRO',            label: 'Outro' },
];

/** Só o nome, sem emoji — para tabelas e chips onde o ícone atrapalha. */
const NOMES = {
  SEMENTE: 'Semente',
  MUDA: 'Muda',
  FERTILIZANTE: 'Fertilizante',
  CORRETIVO: 'Corretivo',
  INOCULANTE: 'Inoculante',
  HERBICIDA: 'Herbicida',
  FUNGICIDA: 'Fungicida',
  INSETICIDA: 'Inseticida',
  BACTERICIDA: 'Bactericida',
  DEFENSIVO: 'Defensivo',
  COMBUSTIVEL: 'Combustível',
  EMBALAGEM: 'Embalagem',
  SERVICO: 'Serviço',
  OUTRO: 'Outro',
};

export const labelCategoria = (v) => NOMES[v] || v || '—';

/** Rótulo para selects — mesmo texto da tabela, sem emoji. */
export const labelCategoriaIcone = (v) =>
  CATEGORIAS.find(c => c.value === v)?.label || labelCategoria(v);

/**
 * Categoria provável a partir do tipo de custo, igual a
 * `CategoriaInsumo.padraoPara` no backend. Serve para pré-selecionar o campo e
 * poupar um clique em quem lança arrendamento ou diária.
 */
const PADRAO_POR_TIPO = {
  PLANTIO: 'SEMENTE',
  ADUBACAO: 'FERTILIZANTE',
  DEFENSIVO: 'DEFENSIVO',
  PULVERIZACAO: 'DEFENSIVO',
  COMBUSTIVEL: 'COMBUSTIVEL',
  ARRENDAMENTO: 'SERVICO',
  MAO_DE_OBRA: 'SERVICO',
  SERVICO: 'SERVICO',
  IRRIGACAO: 'SERVICO',
  FINANCEIRO: 'OUTRO',
  OUTRO: 'OUTRO',
};

export const categoriaPadraoPara = (tipoAplicacao) => PADRAO_POR_TIPO[tipoAplicacao] || 'OUTRO';

/**
 * Rótulos dos tipos de aplicação (manejo). Espelha o enum `TipoAplicacao` do
 * backend. A lista existia só dentro de PainelLavoura (TIPOS_CUSTO); o relatório
 * de custos por lavoura também precisa dela, então fica aqui como fonte única.
 */
const NOMES_TIPO = {
  PLANTIO: 'Plantio',
  ADUBACAO: 'Adubação',
  DEFENSIVO: 'Defensivo',
  PULVERIZACAO: 'Pulverização',
  IRRIGACAO: 'Irrigação',
  ARRENDAMENTO: 'Arrendamento',
  MAO_DE_OBRA: 'Mão de obra',
  COMBUSTIVEL: 'Combustível',
  FINANCEIRO: 'Financeiro',
  SERVICO: 'Serviço',
  OUTRO: 'Outro',
};

export const labelTipoAplicacao = (v) => NOMES_TIPO[v] || v || '—';
